import {
  CardMedia,
  Stack,
  Typography,
  Box,
  Tooltip,
  Dialog,
  IconButton,
  Button,
} from "@mui/material";
import React from "react";
import { TranslateContext } from "../../../../../context/TranslateContext";
import {
  AddShoppingCart,
  Close,
  OpenInNew,
  WhatsApp,
} from "@mui/icons-material";

const PluginCard = ({ title, imageSrc, onClick, isNew }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: 140,
        p: 2,
        m: 1.5,
        borderRadius: 2,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        transition: "all 0.2s",
        position: "relative",
        bgcolor: "background.paper",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
        },
        cursor: "pointer",
      }}
    >
      {isNew && (
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            bgcolor: "#ff4444",
            color: "white",
            borderRadius: "4px",
            px: 1,
            py: 0.5,
            fontSize: "0.7rem",
            fontWeight: "bold",
          }}
        >
          NEW
        </Box>
      )}
      <CardMedia
        sx={{
          height: 80,
          width: 80,
          borderRadius: 2,
          mb: 1.5,
          objectFit: "contain",
        }}
        component={"img"}
        src={imageSrc}
      />
      <Typography
        fontWeight={600}
        variant="body2"
        align="center"
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

const WhatsCRM = ({ buttonDeploy }) => {
  const { data } = React.useContext(TranslateContext);
  const [state, setState] = React.useState({
    dialog: false,
    dialogContent: "",
  });

  const plugins = [
    {
      title: data.AiChatbot,
      imageSrc: "/assets/ai_chatbot_logo_512.png",
      onClick: () =>
        window.open(
          "https://codecanyon.net/item/ai-chat-for-whatsapp-addon-for-whatscrm/52498511",
        ),
      isNew: false,
    },
    {
      title: data.qrCodeLogin,
      imageSrc: "/assets/wacrm_qr_plugin_logo.png",
      onClick: () =>
        window.open(
          "https://codecanyon.net/item/qr-code-login-for-whatsapp-addon-for-whatscrm/57356510",
        ),
      isNew: false,
    },
    {
      title: data.webhookAutomation,
      imageSrc: "/assets/webhook_logo80x80.png",
      onClick: () => {
        setState({ ...state, dialog: true, dialogContent: "WP" });
      },
      isNew: true,
    },
    {
      title: data.embedLogin,
      imageSrc: "/assets/embed_logo80x80.png",
      onClick: () =>
        window.open(
          "https://codecanyon.net/item/embed-whatsapp-login-addon-for-whatscrm/61451340",
        ),
      isNew: true,
    },
    {
      title: data.waCalling,
      imageSrc: "/assets/wacall80x80.png",
      onClick: () =>
        window.open(
          "https://codecanyon.net/item/ai-whatsapp-calling-addon-for-whatscrm/61890622",
        ),
      isNew: true,
    },
    {
      title: data.teleInbox,
      imageSrc: "/assets/telegram.png",
      onClick: () =>
        window.open(
          "https://codecanyon.net/item/whatscrm-telegram-inbox-chatbot-addon/62116168",
        ),
      isNew: true,
    },
  ];

  return (
    <Stack direction={"column"} spacing={4} sx={{ width: "100%", py: 2 }}>
      <Typography variant="h4" align="center" fontWeight={600}>
        {data.addOns}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          maxWidth: 1000,
          mx: "auto",
        }}
      >
        {plugins.map((plugin, index) => (
          <PluginCard
            key={index}
            title={plugin.title}
            imageSrc={plugin.imageSrc}
            onClick={plugin.onClick}
            isNew={plugin.isNew}
          />
        ))}
      </Box>

      <Dialog
        PaperProps={{
          style: {
            borderRadius: 10,
          },
        }}
        fullWidth
        open={state.dialog}
      >
        <Box p={2}>
          <Stack direction={"column"} spacing={2}>
            <Stack alignItems={"flex-end"}>
              <IconButton onClick={() => setState({ ...state, dialog: false })}>
                <Close />
              </IconButton>
            </Stack>

            <Stack direction={"row"} spacing={2} alignItems={"center"}>
              <Button
                onClick={() => {
                  window.open(
                    "https://codecanyon.net/item/webhook-automation-addon-for-whatscrm-automate-woocommerce-shopify-more/58747894",
                  );
                }}
                startIcon={<AddShoppingCart />}
                color="success"
                fullWidth
                variant="contained"
              >
                {data.buyNow}
              </Button>
              <Button
                onClick={() => {
                  window.open(
                    "https://youtu.be/MRNml7O8aBQ?si=e8OY1b2Un3ku2Ijg",
                  );
                }}
                startIcon={<OpenInNew />}
                color="info"
                fullWidth
                variant="contained"
              >
                {data.watchVideo}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Dialog>
    </Stack>
  );
};

export default WhatsCRM;
